import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1306.18122,1110.40706 C1277.72005,1131.18824 1265.86122,1167.66824 1276.70358,1201.43765 L1442.84005,1712.83529 L1007.79064,1396.71294 C979.103577,1375.93176 940.703577,1375.93176 912.12946,1396.71294 L477.080048,1712.83529 L643.32946,1201.21176 C654.171812,1167.66824 642.312989,1131.18824 613.738871,1110.40706 L178.576518,794.284706 L716.402401,794.284706 C751.752989,794.284706 782.924754,771.583529 793.767107,738.04 L960.016518,226.529412 L1126.15299,737.927059 C1136.99534,771.583529 1168.16711,794.284706 1203.51769,794.284706 L1741.45652,794.284706 L1306.18122,1110.40706 Z M1915.95064,737.588235 C1904.99534,703.931765 1873.93652,681.343529 1838.58593,681.343529 L1226.44475,681.343529 L1037.38122,99.2447059 C1026.42593,65.5882353 995.367107,43 960.016518,43 C924.66593,43 893.494165,65.5882353 882.651812,99.2447059 L693.475342,681.343529 L81.3341654,681.343529 C45.9835772,681.343529 14.9247537,703.931765 3.96945955,737.588235 C-6.87289339,771.244706 4.98593014,807.724706 33.5600478,828.505882 L528.807107,1188.22353 L339.517695,1770.43529 C328.675342,1804.09176 340.534165,1840.57176 369.221224,1861.35294 C383.451812,1871.74353 400.280048,1876.93882 416.882401,1876.93882 C433.710636,1876.93882 450.538871,1871.74353 464.76946,1861.24 L960.016518,1501.52235 L1455.03769,1861.24 C1483.61181,1882.13412 1522.12475,1882.13412 1550.81181,1861.35294 C1579.38593,1840.57176 1591.24475,1804.09176 1580.4024,1770.32235 L1391.11299,1188.22353 L1886.36005,828.505882 C1915.04711,807.724706 1926.90593,771.244706 1915.95064,737.588235 L1915.95064,737.588235 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconStarLightLine = /*#__PURE__*/function (_Component) {
  _inherits(IconStarLightLine, _Component);

  var _super = _createSuper(IconStarLightLine);

  function IconStarLightLine() {
    _classCallCheck(this, IconStarLightLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconStarLightLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconStarLight",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconStarLightLine.displayName = "IconStarLightLine";
  return IconStarLightLine;
}(Component);

IconStarLightLine.glyphName = 'star-light';
IconStarLightLine.variant = 'Line';
IconStarLightLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconStarLightLine;
export { IconStarLightLine };